module.exports = {"411472009":"平台街道","411472010":"平安街道","411472200":"周集乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411472.json
// module id = 1662
// module chunks = 0